import useSectionData from './useSectionData';
import { SECTION_ENDPOINTS } from '@/Services/sectionApi';
import { sectionErrors } from '@/data/content';

interface HeaderSectionData {
    logo_url: string;
    navigation_links: unknown[];
    social_links: Record<string, string>;
    phone?: string;
}

const initialHeader: HeaderSectionData = {
    logo_url: '/Design/images/logo.png',
    navigation_links: [],
    social_links: {},
};

const useHeaderData = () => useSectionData(SECTION_ENDPOINTS.header, initialHeader, sectionErrors.header);

export default useHeaderData;
